import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { Button, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { EngagementPostFormValues } from '../../types';

interface FooterButtonsProps {
  onClose?: () => void;
  onSubmit?: () => void;
}

export const FooterButtons = ({ onClose, onSubmit }: FooterButtonsProps) => {
  const { t } = useTranslation();
  const { isAdvertiser } = useUserRoles();
  const {
    formState: { isSubmitting }
  } = useFormContext<EngagementPostFormValues>();

  return onClose || onSubmit ? (
    <Form.Footer className="gap-4">
      {onClose ? <Button onClick={onClose} title={t('Button.Cancel')} /> : null}

      {onSubmit ? (
        <ButtonSubmit
          onClick={onSubmit}
          loading={isSubmitting}
          disabled={isAdvertiser}
          title={t('Button.Save')}
          className="min-w-[unset] px-4"
        />
      ) : null}
    </Form.Footer>
  ) : null;
};
